import React, { useRef, useEffect } from 'react'

import { CSSObject } from '@emotion/react'
import styled from '@emotion/styled'
import {
  Box,
  Space,
  Text,
  Link,
  Color,
  Heading3,
  AlignItems,
  FlexDirection,
  JustifyContent,
  FontFamily,
  Display,
  TextAlign,
  useTheme,
  BoxProps,
} from '@gousto-internal/citrus-react'

import SeedsDesktopImg from '../assets/seeds-desktop.png'
import SeedsMobileImg from '../assets/seeds-mobile.png'

const trustPilotMicroComboWidgetId = '5419b6ffb0d04a076446a9af'

const LeftSeedsArea = (props: BoxProps) => {
  const { theme } = useTheme()

  const Component = styled(Box)(() => ({
    backgroundPosition: 'bottom left',
    backgroundRepeat: 'repeat-x',
    transform: 'rotate(180deg)',
    ...(theme.responsiveStyle(
      [`url(${SeedsMobileImg})`, `url(${SeedsDesktopImg})`],
      ['backgroundImage'],
    ) as CSSObject),
  }))

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} />
}

const RightSeedsArea = (props: BoxProps) => {
  const { theme } = useTheme()

  const Component = styled(Box)(() => ({
    backgroundPosition: 'bottom left',
    backgroundRepeat: 'repeat-x',
    ...(theme.responsiveStyle(
      [`url(${SeedsMobileImg})`, `url(${SeedsDesktopImg})`],
      ['backgroundImage'],
    ) as CSSObject),
  }))

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} />
}

const TrustPilotControl = () => {
  const ref = useRef(null)
  useEffect(() => {
    // widget may not load if the bootstrapper script has been loaded before the component gets rendered
    // we use the TrustPilot loadFromElement function to manually load the widget if this happens

    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true)
    }
  }, [])

  return (
    <Box
      display={Display.Flex}
      flexDirection={[FlexDirection.Column, FlexDirection.Row]}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.SpaceBetween}
      maxHeight="296px"
      minHeight={['240px', '144px']}
      bg={Color.NeutralGrey_50}
      data-testid="TrustPilot"
    >
      <LeftSeedsArea height="4rem" width={['100%', '7.75rem']} minHeight={[null, '9rem']} />
      <Box paddingV={[8, 0]} flexGrow={1}>
        <Box paddingV={0.5}>
          <Heading3 size={[3, 4]} fontFamily={FontFamily.SemiBold} textAlign={TextAlign.Center}>
            Over
            <Text display={Display.Inline} color={Color.Primary_600} fontFamily={FontFamily.Bold}>
              {' '}
              1 million meals{' '}
            </Text>
            cooked and loved
          </Heading3>
        </Box>
        <Space size={4} direction="vertical" />
        <Box width="100%" height={['3rem', '1.25rem']}>
          <div
            ref={ref}
            className="trustpilot-widget"
            data-locale="en-GB"
            data-template-id={trustPilotMicroComboWidgetId}
            data-businessunit-id="512cda6e000064000522fb6a"
            data-style-width="100%"
            data-theme="light"
            data-font-family="Montserrat"
            data-text-color={Color.ColdGrey_800}
            data-testid="TrustPilotContainerControl"
          >
            <Link href="https://uk.trustpilot.com/review/gousto.co.uk" target="_blank">
              Trustpilot
            </Link>
          </div>
        </Box>
      </Box>
      <RightSeedsArea height="4rem" width={['100%', '7.75rem']} minHeight={[null, '9rem']} />
    </Box>
  )
}

export { TrustPilotControl }
